import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { sendMediaMessage, sendMediaMessageFailure, sendMediaMessageSuccess, uploadMedia, uploadMediaFailure, uploadMediaSuccess } from '../actions/message-media.actions';
import { MessageConversationMediaApiService } from '../services/message-conversation-media-api.service';
import { MessageConversationMediaUploadApiService } from '../services/message-conversation-media-upload-api.service';
import { selectCommunicationId } from '../selectors/message-conversation.selectors';
import { MediaState } from '../models/message-media-state.enum';

@Injectable({
  providedIn: 'root'
})
export class GenesysCloudMessageMediaEffects {
  readonly sendMediaMessage$ = createEffect(() => this.actions$.pipe(
    ofType(sendMediaMessage),
    concatLatestFrom(({ conversationId }) => this.store.select(selectCommunicationId(conversationId))),
    mergeMap(([{ conversationId, mediaIds }, communicationId]) => this.api.sendMediaMessage$(
      conversationId,
      communicationId,
      mediaIds
    ).pipe(
      map(() => sendMediaMessageSuccess({ conversationId })),
      catchError(() => of(sendMediaMessageFailure({ conversationId })))
    ))
  ));

  readonly uploadMedia$ = createEffect(() => this.actions$.pipe(
    ofType(uploadMedia),
    concatLatestFrom(({ conversationId }) => this.store.select(selectCommunicationId(conversationId))),
    mergeMap(([{ file, conversationId}, communicationId]) => this.api.getMediaUploadData$(conversationId, communicationId).pipe(
      mergeMap(({ id, uploadUrl }) => this.uploadApi.uploadMedia$(uploadUrl, file).pipe(
          mergeMap(() => this.api.checkMediaStatus$(conversationId, communicationId, id)),
          map(({ status }) => uploadMediaSuccess({ conversationId: conversationId, mediaId: id, status })),
          catchError(() => of(uploadMediaFailure({ conversationId: conversationId, status: MediaState.Invalid })))
      )),
      catchError(() => of(uploadMediaFailure({ conversationId: conversationId, status: MediaState.Invalid })))
    ))
  ));

  constructor(private readonly actions$: Actions,
              private readonly store: Store,
              private readonly api: MessageConversationMediaApiService,
              private readonly uploadApi: MessageConversationMediaUploadApiService
  ) {
  }
}
